import { render, staticRenderFns } from "./packingTraceabilityEdit.vue?vue&type=template&id=23a2b295&scoped=true&"
import script from "./packingTraceabilityEdit.vue?vue&type=script&lang=js&"
export * from "./packingTraceabilityEdit.vue?vue&type=script&lang=js&"
import style0 from "./packingTraceabilityEdit.vue?vue&type=style&index=0&id=23a2b295&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a2b295",
  null
  
)

export default component.exports